export const TitleHoldersSectionTestIds = {
  POPULATE_VESTING_BUTTON: 'title-holders.populate-vesting-button',
  COPY_BORROWERS_BUTTON: 'title-holders.copy-borrowers-button',

  getDeleteButtonId: titleHolderId => `title-holders.delete-button-${titleHolderId}`,
};
